import * as types from './mutation_types';
import {API_ENTRYPOINT} from "../../../config/entrypoint";
import fetch from "../../../utils/fetch";
import {toastError} from "../../../utils/toast";
import {logFrontendError} from "../../../utils/errorLog";

export const reset = ({ commit }) => {
  commit(types.POKEMON_RESET);
};

export const loadItems = ({commit, dispatch}, url) => {
  commit(types.POKEMON_SET_LOADING, true);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.POKEMON_SET_LOADING, false);
      commit(types.POKEMON_SET_ITEMS, data['member']);
    })
    .catch((e) => {
      commit(types.POKEMON_SET_LOADING, false);
      commit(types.POKEMON_SET_ERROR, e.message);
    });
};

// Aktivni tym trenera (max 6, ne v Prof. Oak uloziste, ne ukradeni Team
// Rocketem) - sdileny dotaz pro TeamBottomSheet.vue (globalni lista v
// App.vue) i pro mista, co po zmene tymu/HP potrebuji vynutit refresh
// (CityHealDialog.vue, OakTable.vue) bez primeho $refs na komponentu baru.
export const loadActiveTeam = ({dispatch}, trainerId) => {
  const url = new URL("api/pokemon", API_ENTRYPOINT);
  url.searchParams.set('trainer', trainerId);
  url.searchParams.set('inProfesorOak', false);
  url.searchParams.set('stolen', false);
  url.searchParams.set('order[edited]', 'asc');
  return dispatch('loadItems', url);
};

// Jeden konkretni "updater" pro data, ktera potrebuje TeamBottomSheet.vue
// (aktivni tym + HP) - misto aby si kazde misto v appce muselo pamatovat
// SVOJI vlastni cestu, jak pokemon/items aktualizovat. Dve strategie podle
// toho, co volajici uz ma po ruce:
// - `patch` (uz znama cerstva data jednoho pokemona, napr. odpoved kola
//   souboje) -> lehky shallow-merge bez site navic (POKEMON_PATCH_ITEM).
// - bez `patch` (Camp, Catch, leave/evolve pokemona...) -> plny refetch
//   aktivniho tymu (loadActiveTeam), trainerId se bere sam z user store,
//   volajici ho nemusi znat/predavat.
export const refreshActiveTeam = ({dispatch, commit, rootState}, patch = null) => {
  if (patch && patch.id) {
    commit(types.POKEMON_PATCH_ITEM, patch);
    return Promise.resolve();
  }
  const trainerId = rootState.user.item && rootState.user.item.id;
  if (!trainerId) {
    return Promise.resolve();
  }
  return dispatch('loadActiveTeam', trainerId);
};

// Cache cisel druhu, ktere hrac uz nekdy CHYTIL (Trainer::catchedTypesGen1 +
// catchedTypesAlola, plni Trainer::addPokemon() pri kazdem pridani Pokemon
// entity do sbirky) - NE Trainer::pokedex/pokedexAlola, ktera znamenaji jen
// "videno v souboji" (plni se i pri souboji s trenerem/ligou, viz
// FightService::setTrainerFight/setLeagueFight) a zivym overenim se
// potvrdilo, ze na urcovani "uz chyceno" nejdou pouzit - viz
// docs/superpowers/specs/2026-08-29-catch-button-glow-design.md. Nacte se
// jen jednou za session (pokedexLoaded flag) - force=true (po uspesnem
// ulovku) vynuti cerstva data.
export const loadPokedexNumbers = ({commit, state, rootState, dispatch}, force = false) => {
  if (state.pokedexLoaded && !force) {
    return Promise.resolve();
  }
  const trainerId = rootState.user.item && rootState.user.item.id;
  if (!trainerId) {
    return Promise.resolve();
  }
  const url = new URL(`api/pokedex/${trainerId}`, API_ENTRYPOINT);
  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.POKEMON_SET_POKEDEX_NUMBERS, {catchedTypesGen1: data.catchedTypesGen1, catchedTypesAlola: data.catchedTypesAlola});
    })
    .catch(() => {
      // Vypadek tyhle cache nesmi shodit chytani - glow se proste nezobrazi.
    });
};

export const loadItem = ({commit, dispatch}, id) => {
  commit(types.POKEMON_SET_LOADING, true);
  const url = new URL("api/pokemon/"+id, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch}, id)
    .then((response) => response.json())
    .then((data) => {
      commit(types.POKEMON_SET_LOADING, false);
      commit(types.POKEMON_SET_ITEM, data);
    })
    .catch((e) => {
      commit(types.POKEMON_SET_LOADING, false);
      commit(types.POKEMON_SET_ERROR, e.message);
    });
};

export const updateItem = ({commit, dispatch}, values) => {
  if (!values.id) {
    console.error('Missing user id in values for PATCH /pokemon');
  }
  const url = new URL("api/pokemon/{id}".replace('{id}', values.id),
    API_ENTRYPOINT
  );

  delete values['id'];
  return fetch(url, {dispatch, method: 'PATCH', body: JSON.stringify(values)})
    .then((data) => {
      commit(types.POKEMON_SET_LOADING, false);
      commit(types.POKEMON_SET_ITEM, data);
    })
    .catch((e) => {
      commit(types.POKEMON_SET_LOADING, false);
      commit(types.POKEMON_SET_ERROR, e.message);
    });
};

// Chyba se dřív jen potichu uložila do (nikde nečteného) POKEMON_SET_ERROR
// a slib se přesto VYŘEŠIL s data=undefined - volající (PokemonManager.vue
// buyNewSkill/loadById/leavePokemon/sendEvolvePokemon) pak bez kontroly
// přepsaly this.pokemon na undefined, nebo (leavePokemon) rovnou spustily
// "úspěšný" callback i po neúspěchu. Nalezeno 2026-08-27 při diagnóze
// "aktivní Koupit tlačítko, po kliknutí nic nedělá" u nákupu skillu.
// Teď se chyba stejně jako v journey/actions.js (onJourneyError) přeloží do
// toastu a zaloguje na backend, a slib se PROPAGUJE dál (throw) - volající
// musí mít vlastní .catch(), jinak jim .then(data => ...) prostě neproběhne
// (bezpečnější než dřívější tichý pád na undefined).
function onPokemonFetchError(commit, e) {
  commit(types.POKEMON_SET_LOADING, false);
  commit(types.POKEMON_SET_ERROR, e.message);
  toastError(e.message);
  logFrontendError(e.message, e.stack);
  throw e;
}

export const fetchObject = ({commit, dispatch},obj) => {
  commit(types.POKEMON_SET_LOADING, true);

  if (obj.method === 'GET'){
    return fetch(obj.url, {dispatch: dispatch})
      .then((response) => response.json())
      .then((data) => {
        commit(types.POKEMON_SET_LOADING, false);
        return data;
      })
      .catch((e) => onPokemonFetchError(commit, e));
  }
  // OTHER
  return fetch(obj.url, {method: obj.method, body: JSON.stringify(obj.obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.POKEMON_SET_LOADING, false);
      return data;
    })
    .catch((e) => onPokemonFetchError(commit, e));
};
